import * as React from 'react';

import LoginForm from '../containers/auth/LoginForm';

export default function(params) {
  return (
    <React.Fragment>
      <div className="log__cont">
        <LoginForm />
      </div>
    </React.Fragment>
  );
};

